// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-L4JO","col":"styles_col__36yz6"};